import { render, staticRenderFns } from "./SearchCompany.vue?vue&type=template&id=3f5f72dd&scoped=true"
import script from "./SearchCompany.vue?vue&type=script&lang=js"
export * from "./SearchCompany.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f5f72dd",
  null
  
)

export default component.exports